import { render, staticRenderFns } from "./keben.vue?vue&type=template&id=25c30c9a&scoped=true"
import script from "./keben.vue?vue&type=script&lang=js"
export * from "./keben.vue?vue&type=script&lang=js"
import style0 from "./keben.vue?vue&type=style&index=0&id=25c30c9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c30c9a",
  null
  
)

export default component.exports